// extracted by mini-css-extract-plugin
export var orderSummary = "_qc-0";
export var showMoreLessButton = "_qc-1";